import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { IIdentifiable } from 'interfaces/common';
import { IPaymentStatusType } from 'interfaces/payments';

import { IColumnsConfig } from 'components/_basic/OutletTable/types';

import { SavePaymentHistoryButton } from './components/SavePaymentHistoryButton';
import { ViewPaymentHistoryButton } from './components/ViewPaymentHistoryButton';

export interface IPaymentHistoryRow extends IIdentifiable {
  date: string;
  cost: string;
  plan: string;
  operationId: string;
  receipt: string | null;
  status: IPaymentStatusType;
}

export const useGetColumns = () => {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const columns: IColumnsConfig<IPaymentHistoryRow> = [
      {
        id: 'date',
        title: t('date'),
      },
      {
        id: 'cost',
        title: t('cost'),
      },
      {
        id: 'plan',
        title: t('plan'),
      },
      {
        id: 'operationId',
        title: t('operationID'),
      },
      {
        id: 'view',
        title: '',
        cellStyle: { boxSizing: 'border-box', width: '70px', maxWidth: '70px', padding: 0 },
        Cell: ({ item }) => <ViewPaymentHistoryButton paymentHistory={item} />,
      },
      {
        id: 'save',
        title: '',
        cellStyle: { boxSizing: 'border-box', width: '70px', maxWidth: '70px', padding: 0 },
        Cell: ({ item }) => <SavePaymentHistoryButton paymentHistory={item} />,
      },
    ];
    return columns;
  }, [t, i18n]);
};

export const columns: IColumnsConfig<IPaymentHistoryRow> = [
  {
    id: 'date',
    title: 'Date',
  },
  {
    id: 'cost',
    title: 'Cost',
  },
  {
    id: 'plan',
    title: 'Plan',
  },
  {
    id: 'operationId',
    title: 'Operation ID',
  },
  {
    id: 'view',
    title: '',
    cellStyle: { boxSizing: 'border-box', width: '70px', maxWidth: '70px', padding: 0 },
    Cell: ({ item }) => <ViewPaymentHistoryButton paymentHistory={item} />,
  },
  {
    id: 'save',
    title: '',
    cellStyle: { boxSizing: 'border-box', width: '70px', maxWidth: '70px', padding: 0 },
    Cell: ({ item }) => <SavePaymentHistoryButton paymentHistory={item} />,
  },
];
